<template>
  <span><!-- please see styling in head section--></span>
</template>

<script>
export default {
  name: 'StyleInjector',
  props: {
    appStyle: String,
  },
  data() {
    return {}
  },
  mounted() {
    const styl = document.createElement("style")
    const appStyle = decodeURI(this.appStyle)
    const txtNode = document.createTextNode(appStyle)
    styl.append(txtNode)
    this.$el.replaceWith(styl)
  },
}
</script>